module.exports = __webpack_public_path__ + "img/station.9e565052.jpg";